export default [{
        name: 'Home',
        icon: 'fas fa-home',
        path: '/welcome'
    },
    {
        name: 'Dashboard',
        icon: 'fas fa-chart-line',
        path: '/admin/overview'
    },

    {
        name: 'Projects',
        icon: 'fas fa-tasks',
        children: [{
                name: 'All Project',
                path: '/projects/internal'

            },
            // {
            //     name: 'New Project',
            //     path: '/projects/internal/:new'

            // },

        ]
    },
    {
        name: 'Examinations',
        icon: 'fas fa-cogs',
        children: [{
                name: 'Global',
                path: '/examinations/myworkflow'
            },
            {
                name: 'Local',
                path: '/examinations/mysubject'
            },

        ]
    },
    // {
    //     name: 'Executions',
    //     icon: 'fas fa-chart-bar',
    //     children: [{
    //         name: 'Executions',
    //         path: '/executions/internal'
    //     }, ]
    // },
    // {
    //     name: 'Analyses',
    //     icon: 'fas fa-chart-line',
    //     children: [{
    //             name: 'Workflows',
    //             path: '/analyses/anworkflows'
    //         },
    //         {
    //             name: 'Genes',
    //             path: '/analyses/angenes'
    //         },
    //     ]
    // },
    // {
    //     name: 'Filters',
    //     icon: 'fas fa-star',
    //     children: [{
    //             name: 'Create New',
    //             path: '/favorites/blankpage'
    //         },
    //         {
    //             name: 'Show All',
    //             path: '/favorites/next'
    //         },
    //     ]
    // },
    // {
    //     name: 'Reports',
    //     icon: 'fas fa-paper-plane',
    //     children: [{
    //             name: 'Create Template',
    //             path: '/reports/blankpage'
    //         },
    //         {
    //             name: 'Show all',
    //             path: '/reports/next'
    //         },
    //     ]
    // },
    // {
    //     name: 'Settings',
    //     icon: 'fas fa-cogs',
    //     collapsed: true,
    //     children: [{
    //             name: 'Accounts',
    //             path: '/settings/accounts'
    //         },
    //         {
    //             name: 'Workflows',
    //             path: '/settings/workflows'
    //         },

    //     ]
    // },
    {
        name: 'Links',
        icon: 'fas fa-link',
        collapsed: true,
        children: [{
                name: 'Links',
                path: '/links/sources'
            },

        ]
    },
    {
        name: 'Examination Sheet',
        icon: 'fas fa-table',
        path: '/examination_sheet'
    },

]